var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWindowFrameOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M504 496H480V328C480 323.594 476.406 320 472 320S464 323.594 464 328V496H48V328C48 323.594 44.406 320 40 320S32 323.594 32 328V496H8C3.594 496 0 499.594 0 504S3.594 512 8 512H504C508.406 512 512 508.406 512 504S508.406 496 504 496ZM40 288H472C476.406 288 480 284.406 480 280V40C480 17.938 462.062 0 440 0H72C49.938 0 32 17.938 32 40V280C32 284.406 35.594 288 40 288ZM264 16H440C453.219 16 464 26.781 464 40V272H264V16ZM48 40C48 26.781 58.781 16 72 16H248V272H48V40Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowFrameOpen);
export default __webpack_public_path__ + "static/media/window-frame-open.583d13b328fde3b453659ecb870da88b.svg";
export { ForwardRef as ReactComponent };